module.exports = __webpack_public_path__ + "static/media/Es-ist-so-einfach1.42a5c5c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Es-ist-so-einfach1.jpg
// module id = 243
// module chunks = 8